import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import useLocalStorageState from "use-local-storage-state"
import { PipelineEditor } from "./PipelineEditor"
import { toast } from "sonner"
import { usePostRequest, useGetRequest } from "../../Utils/hooks/QueryHandler"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"

export const CreatePipelinePage = ({
  module_name,
  refetchPipelineData,
  setCreatePipeline,
  setSelectedPipelineId,
  pipelineGrant
}) => {
  // extracting params from the url
  // const [searchParams] = useSearchParams();
  // const module_name = searchParams.get('module')

  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()

  // Fetch pipelines data for counting purposes
  const { data: pipelineApiData, refetch: refetchPipeline } = useGetRequest(
    `${module_name}/fetchPipelines/${customerId}/${module_name}s/${loginUserId}/${userType}`,
    "fetchPipelinesForCount",
    headers,
    extras,
    {
      enabled: !!customerId,
    },
  )

  // Create pipeline mutation hook
  const { mutate: createPipeline } = usePostRequest(`lead/createPipeline/${module_name}s`, false, { headers }, extras)

  // Handle saving new pipeline via API and refetch pipelines list
  const handleSavePipeline = async (updatedData, hasActualChanges = true) => {
    try {
      const stagesPayload = updatedData.pipeline_stage.map((stage) => ({
        stage_name: stage.stage_name,
        stage_id: stage.stage_id ? String(stage.stage_id) : "",
        sequence: stage.sequence,
        rotting_days: stage.rotting_days || null,
        probability: Math.min(100, stage.probability),
        color: stage.color || null, // Add color field
      }))

      const payload = {
        customer_id: customerId,
        pipeline_name: updatedData.pipeline_name,
        user_login_id: loginUserId,
        pipeline_stage: stagesPayload,
        module_name: `${module_name}s`
      }
      createPipeline(payload, {
        onSuccess: async (response) => {
          if (response?.status === "success") {
            toast.success(response.message || "Pipeline created successfully")
            setSelectedPipelineId(response.data && response?.data)
            refetchPipelineData()
            setCreatePipeline(false)
          } else {
            toast.error(response?.message || "Failed to create pipeline")
          }
        },
        onError: (error) => {
          toast.error("An error occurred while creating pipeline")
        },
      })
    } catch (error) {
      toast.error("An error occurred while saving pipeline")
      throw error
    }
  }

  // Navigate back to leads page
  const handleCancel = () => {
    setCreatePipeline(false)
  }

  // Handle temporary stage deletion (no API call needed for unsaved stages)
  const handleStageDeleteRequest = (stageId) => {
    return Promise.resolve()
  }

  return (
    <PipelineEditor
      pipelineName="New Pipeline"
      pipelineStage={[]}
      onClose={handleCancel}
      onSave={handleSavePipeline}
      onDuplicate={() => { }} // Not applicable for create
      onDeletePipeline={() => { }} // Not applicable for create
      onStageDeleteRequest={handleStageDeleteRequest}
      pipelineCount={pipelineApiData?.data?.length || 1}
      isCreatingNewPipeline={true}
      leadsData={[]}
      isCreate={true}
    />
  )
}
